(function () {
  function ttqReady(callback) {
    if (window.ttq && typeof window.ttq.track === 'function') return callback();
    var attempts = 0;
    var interval = setInterval(function () {
      attempts += 1;
      if (window.ttq && typeof window.ttq.track === 'function') {
        clearInterval(interval);
        callback();
      } else if (attempts > 40) {
        clearInterval(interval);
      }
    }, 250);
  }

  function trackAddToCart(item) {
    ttqReady(function () {
      window.ttq.track('AddToCart', {
        content_id: item.sku || String(item.variant_id || item.id),
        content_type: 'product',
        content_name: item.product_title || item.title,
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'COP',
        value: (item.final_line_price || item.line_price || item.price || 0) / 100,
        quantity: item.quantity || 1,
      });
    });
  }

  // Poll /cart.js for changes instead of hooking fetch/forms directly: the
  // theme (and possibly other apps) already wrap window.fetch, so relying on
  // that ordering is fragile. Comparing cart snapshots is robust regardless
  // of which UI path (product form, quick add, shop-the-look, etc) added the item.
  var lastSnapshot = null;

  function snapshotKey(items) {
    return items.map(function (i) { return i.key + ':' + i.quantity; }).join('|');
  }

  function pollCart() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var key = snapshotKey(cart.items);
        if (lastSnapshot === null) {
          lastSnapshot = key;
          return;
        }
        if (key === lastSnapshot) return;

        var prevKeys = {};
        lastSnapshot.split('|').forEach(function (pair) {
          var parts = pair.split(':');
          prevKeys[parts[0]] = parseInt(parts[1], 10) || 0;
        });

        cart.items.forEach(function (item) {
          var prevQty = prevKeys[item.key] || 0;
          if (item.quantity > prevQty) {
            trackAddToCart(
              Object.assign({}, item, { quantity: item.quantity - prevQty })
            );
          }
        });

        lastSnapshot = key;
      })
      .catch(function () {
        /* silent */
      });
  }

  pollCart();
  setInterval(pollCart, 1500);

  // InitiateCheckout: fire when the shopper heads to checkout from the cart
  // (cart page checkout button, cart drawer checkout button, or any link to /checkout).
  document.addEventListener(
    'click',
    function (event) {
      var target = event.target.closest(
        'button[name="checkout"], a[href*="/checkout"], input[name="checkout"]'
      );
      if (!target) return;
      ttqReady(function () {
        window.ttq.track('InitiateCheckout');
      });
    },
    true
  );
})();
